// result-json-schema-controller-owned-fields.ts
//
// Fields of the worker `result` the CONTROLLER fills in, which the worker-facing
// JSON schema must not offer (close-out A', dogfood C 2026-09-30: a listed
// optional `input_hash` made 2/23 attempts fill it with 64 zeros). The zod
// schema keeps them, so an older worker that still sends one is parsed and
// cross-checked. ONE helper for both places the schema is published: the
// `--json-schema` argv string (autopilot-result-schema.ts) and the text behind
// the pack file / `avatar autopilot schema result` (json-schema-text-from-zod.ts).
// A leaf module on purpose — both of those import it, it imports nothing.
export const CONTROLLER_OWNED_RESULT_FIELDS: readonly string[] = ["input_hash"];

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/**
 * Copy of `schema` without the controller-owned properties (and without their
 * names in `required`). Guarded: anything that is not an object schema with a
 * `properties` object (a `$ref`/`$defs` root, say) comes back untouched rather
 * than throwing on a user's machine.
 */
export function omitControllerOwnedResultFields<T>(schema: T): T {
  if (!isPlainObject(schema) || !isPlainObject(schema.properties)) return schema;
  const properties = Object.fromEntries(
    Object.entries(schema.properties).filter(
      ([name]) => !CONTROLLER_OWNED_RESULT_FIELDS.includes(name),
    ),
  );
  const required = Array.isArray(schema.required)
    ? schema.required.filter((name) => !CONTROLLER_OWNED_RESULT_FIELDS.includes(name as string))
    : undefined;
  return { ...schema, properties, ...(required === undefined ? {} : { required }) } as T;
}
